export const InvoiceTypeName = {
    sold: {value: 'sold', name: 'فروش'},
    bought: {value: 'bought', name: 'خرید'},
    income: {value: 'income', name: 'درآمد'},
    cost: {value: 'cost', name: 'هزینه'},
    return_from_sold: {value: 'rs', name: 'بازگشت از فروش'},
    return_from_bought: {value: 'rb', name: 'بازگشت از خرید'},
    transfer: {value: 'transfer', name: 'انتقال'},
}